import { BEACON_OF_GUIDANCE_INDEX, THIS_WEEK_WITH_HUZOOR_INDEX } from './backendInfo';


const HUZOOR_DETAIL_FIELDS = [
    'tab',
    'term',
    'qtype',
    'stype',
    'episode_id',
    'qa_language',
    'question_id',
];


export const detailRequestParams = params => {
    if (!params || ![THIS_WEEK_WITH_HUZOOR_INDEX, BEACON_OF_GUIDANCE_INDEX].includes(params.tab)) {
        return params;
    }

    return HUZOOR_DETAIL_FIELDS.reduce((requestParams, field) => {
        if (params[field] !== undefined && params[field] !== null) {
            requestParams[field] = params[field];
        }
        return requestParams;
    }, {});
};
